module.exports = "/_next/static/images/a6551e302c7b6cd3a96d20ff3cf71fa8-stapler@mobile320.jpg.webp";